import React from 'react'
import { Form, Image, Modal } from 'react-bootstrap'
import RejectIcon from "../../../assets/images/reject.svg";

const CancelRequestOrderModal = (props) => {
  return (
    <Modal
        show={props.showCancelRequest}
        onHide={props.handleCloseCancelRequest}
        centered
        className="deliva-popup"
      >
        <Modal.Body>
          <div className="modal-content-wrap ">
            <div className="text-center">
              <Image src={RejectIcon} className="img-fluid reject-img " />
              <h4 className=" mt-4 font-weight-normal mb-3 fs-24">
                {`Cancellation confirmation`}
              </h4>
              <p className="color-grey">
                {props.type === "request"
                  ? "Are you sure you want to cancel this delivery request?"
                  : "Are you sure you want to cancel this delivery order?"}
              </p>
            </div>

            <Form.Group controlId="exampleForm.ControlTextarea1" className="custom-form">
              <Form.Label className="color-head">
                Reason
              </Form.Label>
              <Form.Control
                as="textarea"
                rows="3"
                name="cancellationRemark"
                onChange={(e) => props.handleCancelReason(e.target.value)}
                maxLength="100"
                style={{ resize: 'none' }}
              />
              <span className="min-char d-block">Max 100 chars</span>
            </Form.Group>
            <div className="text-center">
              <button
                className="cancel-btn mr-4 min-w-80"
                onClick={props.handleCloseCancelRequest}
              >
                No
              </button>
              <button
                className="b1-btn min-w-80"
                onClick={props.cancelDeliveryOrder}
              >
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
  )
}

export default CancelRequestOrderModal